import { useState, useEffect } from 'react';

/**
 * useMediaQuery — responsive breakpoint hook
 * Desktop ≥1024, Tablet 768-1023, Mobile <768
 */
export default function useMediaQuery() {
  const [breakpoint, setBreakpoint] = useState('desktop');

  useEffect(() => {
    const check = () => {
      const w = window.innerWidth;
      setBreakpoint(w >= 1024 ? 'desktop' : w >= 768 ? 'tablet' : 'mobile');
    };
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return {
    breakpoint,
    isMobile: breakpoint === 'mobile',
    isTablet: breakpoint === 'tablet',
    isDesktop: breakpoint === 'desktop',
  };
}
